//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "BlueResultsItem",
  props: ["result", "formatDate", "openInNewWindow"],
  computed: {
    date() {
      return this.formatDate(this.result.itemDate, "MMM dd, yyyy");
    },
  },
};
